import ZkArea from './src/main.vue'
ZkArea.install = function (Vue) {
  Vue.component(ZkArea.name, ZkArea)
}

export default ZkArea



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/area/index.js